import React, { useMemo, useState } from 'react'

import { Box, Stack } from '@chakra-ui/react'
import { useParams } from 'react-router'
import {
  Breadcrumb,
  BreadcrumbParam,
} from 'src/components/__legacy__/breadcrumb/breadcrumb'
import { Modal } from 'src/components/__legacy__/modal/modal'
import { usePermission } from 'src/features/auth/context'
import { Template } from 'src/legacy_modules/entities/template/entity'
import { Worksheet } from 'src/legacy_modules/entities/worksheet/entity'
import { PERMISSIONS } from 'src/lib/permission'

import { PreviewLoglineDetail } from './logline-detail'
import {
  PreviewWorksheetProvider,
  usePreviewWorksheet,
} from './preview-worksheet-context'
import { createWorksheetWithLogline } from './utils'
import { PreviewWorksheet } from './worksheet'

type Props = {
  onClose: () => void
  template: Template
  templateFolderName: string
}

export const PreviewModal: React.FC<Props> = props => {
  const { template, templateFolderName, onClose } = props
  const { patientUid = '' } = useParams<{
    patientUid: string
  }>()
  const { hasPermission } = usePermission()

  const visibilityIconVisible = hasPermission(PERMISSIONS.Template_SetHospitals)

  const originalWorksheet: Worksheet = useMemo(
    () =>
      createWorksheetWithLogline({
        template,
        patientUid,
        visibilityIconVisible,
      }),
    [template, patientUid, visibilityIconVisible],
  )

  return (
    <PreviewWorksheetProvider originalWorksheet={originalWorksheet}>
      <PreviewModalBody
        onClose={onClose}
        templateFolderName={templateFolderName}
      />
    </PreviewWorksheetProvider>
  )
}

type BodyProps = {
  onClose: () => void
  templateFolderName: string
}

const PreviewModalBody: React.FC<BodyProps> = ({
  onClose,
  templateFolderName,
}) => {
  const { worksheet } = usePreviewWorksheet()

  const [currentLoglineUid, setLoglineUid] = useState<string | null>(null)
  const onChangeLoglineUid = (uid: string | null) => {
    setLoglineUid(uid)
  }

  const breadCrumbParams: BreadcrumbParam[] = [
    { label: templateFolderName, isLink: false },
    { label: worksheet.title, isLink: false },
  ]

  return (
    <Modal onClose={onClose} size="L">
      <Stack w="100%" h="100%">
        {!!currentLoglineUid ? (
          <Box>
            <PreviewLoglineDetail
              worksheet={worksheet}
              currentLoglineUid={currentLoglineUid}
              onChangeLoglineUid={onChangeLoglineUid}
              templateFolderName={templateFolderName}
            />
          </Box>
        ) : (
          <Box>
            <Breadcrumb breadcrumbParams={breadCrumbParams} />

            <PreviewWorksheet
              worksheet={worksheet}
              onChangeLoglineUid={onChangeLoglineUid}
            />
          </Box>
        )}
      </Stack>
    </Modal>
  )
}
